"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStore = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const services_1 = require("../services");
class CollectionStore {
    has(revision) {
        const rest = services_1.Services.Department.rest;
        const ikeCollection = rest.Collection.getModel(revision);
        if (!ikeCollection.hasFetched) {
            return false;
        }
        return ikeCollection.hasFetched;
    }
    get(revision) {
        var _a;
        if (!revision) {
            return null;
        }
        const rest = services_1.Services.Department.rest;
        const collection = (_a = rest.Collection.getModel(revision)) === null || _a === void 0 ? void 0 : _a.value;
        if (collection == null) {
            return null;
        }
        return collection;
    }
    getHistory(collectionUuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const query = services_1.Services.Department.rest.query(core_shared_1.IkeRestObjects.CollectionHistory);
            query.where.uuid = collectionUuid;
            return query.findAll();
        });
    }
    fetch(revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = services_1.Services.Department.rest;
            return yield rest.Collection.getModel(revision).fetch();
        });
    }
    search(text) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const currentDepartment = services_1.Services.Department.current;
            if (currentDepartment == null) {
                return Promise.resolve([]);
            }
            const data = {
                type: 'collection',
                text
            };
            const response = yield services_1.Services.Department.rest.Collection.search(data);
            return response.results;
        });
    }
}
exports.CollectionStore = CollectionStore;
//# sourceMappingURL=collection.store.js.map